
import { ICommerceProduct } from '../models/order.model';
import * as fromProductsCommerce from './commerce-product.action';

export interface productsCommerceState {
    products: ICommerceProduct[];
}

const estadoInicial: productsCommerceState = {
    products: []
};


export function productsCommerceReducer(state = estadoInicial, action: fromProductsCommerce.acciones): productsCommerceState {

    switch (action.type) {

        case fromProductsCommerce.SET_PRODUCT_COMMERCE:
            return {
                ...state,
                products: action.products
            };

        case fromProductsCommerce.UNSET_PRODUCT_COMMERCE:
            return {
                products: []
            };

        default:
            return state;

    }

}